/**
 * Dayoffs module tour demos
 * Demo HTML templates specific to dayoffs module
 */

import type { TourDemoType } from '../types'
import { demoText as td } from '../../i18n'

/**
 * Generate dayoff-specific demo HTML
 * Returns empty string if demo is not dayoff-related
 */
export const getDayoffDemoHTML = (demo?: TourDemoType): string => {
    if (!demo) return ''

    switch (demo) {
        case 'sidebar-menu-expand-dayoff':
            return `
            <div class="tour-demo" style="padding: 12px;">
                <div style="width: 200px; background: white; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); overflow: hidden;">
                    <!-- Parent menu item -->
                    <div style="padding: 10px 12px; display: flex; align-items: center; gap: 10px; background: #f8fafc; border-left: 3px solid #3b82f6; cursor: pointer; animation: tour-plus-pulse 1.5s ease-in-out infinite;">
                        <div style="width: 24px; height: 24px; background: #e0e7ff; border-radius: 6px; display: flex; align-items: center; justify-content: center;">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                        </div>
                        <span style="font-size: 12px; font-weight: 500; color: #1f2937; flex: 1;">${td('sidebar-menu-expand-dayoff', 'menu_group_account')}</span>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" style="transition: transform 0.3s;"><path d="M6 9l6 6 6-6"/></svg>
                    </div>
                    <!-- Submenu items (collapsed) -->
                    <div style="height: 0; overflow: hidden; transition: height 0.3s; animation: tour-submenu-expand 2s ease-in-out infinite;">
                        <div style="padding: 8px 12px 8px 46px; font-size: 11px; color: var(--vn-fg-muted);">${td('sidebar-menu-expand-dayoff', 'menu_item_account')}</div>
                        <div style="padding: 8px 12px 8px 46px; font-size: 11px; color: var(--vn-fg-muted);">${td('sidebar-menu-expand-dayoff', 'cong_tac')}</div>
                        <div style="padding: 8px 12px 8px 46px; font-size: 11px; color: #3b82f6; font-weight: 500; background: #eff6ff;">${td('sidebar-menu-expand-dayoff', 'nghi_phep')}</div>
                    </div>
                </div>
                <style>
                    @keyframes tour-submenu-expand {
                        0%, 30% { height: 0; }
                        50%, 100% { height: 90px; }
                    }
                </style>
            </div>
        `

        default:
            return ''
    }
}
